import { api } from '../api';
import {
  GlobalSettingsDto,
  CreateGlobalSettingDto,
  UpdateGlobalSettingDto,
  TournamentSettingDto,
  SettingCategory,
} from '@repo/common-types';
import { UpdateTournamentSettingDto } from '@repo/common-types/src/dto/table/settings.dto';

// Global Settings
export const getGlobalSettingsRest = async (): Promise<GlobalSettingsDto[]> => {
  const response = await api.get<GlobalSettingsDto[]>('/v1/settings');
  return response.data;
};

export const getGlobalSettingsByCategoryRest = async (category: SettingCategory): Promise<GlobalSettingsDto[]> => {
  const response = await api.get<GlobalSettingsDto[]>(`/v1/settings?category=${category}`);
  return response.data;
};

export const createGlobalSettingRest = async (data: CreateGlobalSettingDto): Promise<GlobalSettingsDto> => {
  const response = await api.post<GlobalSettingsDto>('/v1/settings', data);
  return response.data;
};

export const updateGlobalSettingRest = async (
  key: string,
  data: UpdateGlobalSettingDto,
): Promise<GlobalSettingsDto> => {
  const response = await api.patch<GlobalSettingsDto>(`/v1/settings/${key}`, data);
  return response.data;
};

// Tournament Settings
export const getTournamentSettingsRest = async (tournamentId: string): Promise<TournamentSettingDto[]> => {
  const response = await api.get<TournamentSettingDto[]>(`/v1/settings/tournaments/${tournamentId}`);
  return response.data;
};

export const updateTournamentSettingRest = async (
  tournamentId: string,
  key: string,
  data: UpdateTournamentSettingDto,
): Promise<TournamentSettingDto> => {
  const response = await api.patch<TournamentSettingDto>(`/v1/settings/tournaments/${tournamentId}/keys/${key}`, data);
  return response.data;
};
